<template>
  <div>
    <button @click.stop="copyMessage">
      <truncate-text-with-hover
        v-if="textTruncateLenght"
        :text="message"
        :length="textTruncateLenght"
      />
      <span v-else>{{ message }}</span>
    </button>
    <v-tooltip bottom v-model="success">
      <template v-slot:activator="{}"><div /></template>
      <span class="caption">Copié</span>
    </v-tooltip>
    <label>
      <input
        style="position: absolute; top: 0; opacity: 0; z-index: -100"
        type="text"
        ref="message"
        :value="message"
      />
    </label>
  </div>
</template>

<script>
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';

export default {
  name: 'CopyToClipboard',
  components: { TruncateTextWithHover },
  props: {
    message: {
      required: false,
    },
    textTruncateLenght: {
      required: false,
    },
  },
  data() {
    return {
      success: false,
    };
  },
  watch: {
    success(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.success = false;
        }, 1000);
      }
    },
  },
  methods: {
    copyMessage() {
      const messageToCopy = this.$refs.message;
      messageToCopy.select();

      try {
        this.success = document.execCommand('copy');
      } catch (err) {
        // eslint-disable-next-line no-alert
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
  },
};
</script>
